import React, { useState } from "react";
import styled from "styled-components";
import LeftNav from "./LeftNav";
import { menuBar } from "../../../assets/images";

const StyledBurger = styled.div`
  width: 1.7rem;
  height: 1.7rem;
  position: absolute;
  top: ${({ open }) => (open ? "20px" : "20px")};
  // right: ${({ open }) => (open ? "45px" : "15px")};
  display: flex;
  justify-content: space-around;
  flex-flow: column nowrap;
  align-items: flex-end;
  z-index: 2000000;
  right: 20px;

  div {
    width: 1.7rem;
    height: 0.15rem;
    background-color: ${({ open }) => (open ? "#000" : "#000")};
    border-radius: 10px;

    transform-origin: 1px;
    transition: all 0.3s linear;

    &:nth-child(1) {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
      width: 1.7rem;
    }

    &:nth-child(2) {
      transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
      width: 0.8rem;
      opacity: ${({ open }) => (open ? 0 : 1)};
    }

    &:nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
      width: ${({ open }) => (open ? "1.7rem" : "1.3rem")};
    }
  }
`;

const Burger = () => {
  const [open, setOpen] = useState(false);
  const [openLogoutPage, setOpenLogoutPage] = useState(false);

  return (
    <>
      <StyledBurger
        style={{ display: `${openLogoutPage ? "none" : "flex"}` }}
        open={open}
        onClick={() => setOpen(!open)}
      >
        <div />
        <div />
        <div />
        {/* <img src={menuBar} /> */}
      </StyledBurger>

      <LeftNav
        open={open}
        openLogoutBtn={() => setOpenLogoutPage(!openLogoutPage)}
        closeLogoutBtn={() => setOpenLogoutPage(false)}
        openLogoutPage={openLogoutPage}
        closeNavBar={() => setOpen(!open)}
      />
    </>
  );
};

export default Burger;
